export interface ShameEntry {
  id: string;
  displayName: string;
  username: string;
  initials: string;
  avatarColor: string;
  category: string;
  categoryIcon: string;
  stat: string;
  statLabel: string;
  description: string;
  period: string;
  badge: string;
}

// Empty — add real entries manually
export const SHAME_ENTRIES: ShameEntry[] = [];

export const SHAME_CATEGORIES = [
  'All',
  '3AM Texter',
  'Professional Lurker',
  'Serial Group Joiner',
  'Reply Avoider',
  'Group Ghost',
  'Most Chaotic Week',
];

export const SHAME_STATS = [
  { label: 'Shame Entries', value: '0', icon: '😬' },
  { label: 'Total Chaos Messages', value: '0', icon: '💬' },
  { label: 'Groups Abandoned', value: '0', icon: '👻' },
  { label: 'Messages Deleted', value: '0', icon: '🗑️' },
];
